import { appFetch } from "../../utils/appFetch";

export interface AppFetchResponse {
    data: any;
    status: number;
}

function unwrap<T>(res: AppFetchResponse): { ok: boolean; data?: T; error?: string } {
    const ok = res.status >= 200 && res.status < 300;
    const payload = res?.data;
    if (payload && typeof payload === "object" && "data" in payload) {
        return { ok, data: (payload as any).data as T, error: (payload as any).error };
    }
    return { ok, data: payload as T, error: (payload as any)?.error };
}

export const postAgentChat = async (
    selectedDomain: string,
    body: {
    conversation_id?: string | null;
    message: string;
    turnstile_token?: string;
    input?: any;
}) => {
    const res: AppFetchResponse = await appFetch({
        endpoint: `v2/agent/chat`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        domain: selectedDomain,
        params: body,
    });

    return unwrap<{
        conversation_id: string;
        reply: string;
        stage?: number;
        state?: any;
        action?: "start_onboarding" | "login" | "show_pricing" | "none";
        action_label?: string;
        start_onboarding?: boolean;
        language?: string;
        is_rtl?: boolean;
        pricing_plans?: Array<{
            id: number;
            title: string;
            description?: string;
            fee: number;
            freeCreditPerCycle?: number;
            freeConversationMessagesPerCycle?: number;
            isPhoneNumberIncluded: boolean;
            badge?: string;
            cta?: string;
        }>;
    }>(res);
};
